import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube as fabFaYoutube } from '@fortawesome/free-brands-svg-icons';

import Video from 'Components/Utility/Video';
import FluidImg from 'Components/Utility/FluidImg';
import ProductCover from 'Components/Utility/ProductCover';

export default function VideoImgLoader({
  cover,
  video,
  sizesOverride,
  index,
  location,
  displayType,
  folder,
}) {
  const [showVideo, setShowVideo] = useState(false);

  const loadVideo = (e) => {
    if (e) e.preventDefault();
    setShowVideo(true);
  };

  useEffect(() => {
    setShowVideo(false);
  }, [video]);

  return (
    <>
      {showVideo &&
        <div className="video-wrapper">
          <Video width="100%" height="auto" src={video} className="youtube-video" location={location} />
        </div>
      }
      {!showVideo &&
        <div className="product-video-container">
          {cover ?
            <ProductCover
              cover={cover}
              alt={`Product cover for ${cover}`}
              displayType={displayType}
              sizesOverride={sizesOverride}
              folder={folder}
            />
            :
            <div className="responsive-image-island">
              <div className="responsive-image responsive-image--16by9">
                <FluidImg
                  ratio16by9
                  className="m-auto img-force-full youtube-cover"
                  youtubeId={video}
                  alt={'Video Preview'}
                  lazy={index !== 0}
                  sizesOverride={sizesOverride}
                />
              </div>
            </div>
          }
          <div className="product-video-icon-container">
            <Button aria-label="Play video" color="link" onClick={e => loadVideo(e)}>
              <FontAwesomeIcon icon={fabFaYoutube} title="YouTube" />
            </Button>
          </div>
        </div>
      }
    </>
  );
}

VideoImgLoader.propTypes = {
  cover: PropTypes.string,
  video: PropTypes.string,
  sizesOverride: PropTypes.string,
  index: PropTypes.number,
  location: PropTypes.string,
  displayType: PropTypes.string,
  folder: PropTypes.string,
};

VideoImgLoader.defaultProps = {
  cover: '',
  video: '',
  sizesOverride: '',
  index: null,
  location: '',
  displayType: '',
  folder: 'product',
};
